import React, { useState } from 'react'
import ModalValidarEnfermefoJefeDevolucionesQx from './ModalValidarEnfermefoJefeDevolucionesQx'
//import ModalValidarEnfermeriaDevoluciones from './ModalValidarEnfermeriaDevoluciones'

const TablaListaPersonalEnfermeriaDevolucionesQx = ({item,passDataSeleccionarEnfermero}) => {
  const [modalOnValidarEnfermoJefe,setmodalOnValidarEnfermoJefe]=useState(false)  
  const enfermeria={
        idEnfermeria: item.MMCODM,
        nombreEnfermeria: item.MMNomM
      }
      const handleOnclickSeleccionarEnfermero=()=>{
        // if(item.MMTpoServ === '4' || item.MMTpoServ === 4){
        //   setmodalOnValidarEnfermoJefe(true)
        // }else{
          passDataSeleccionarEnfermero(enfermeria)
        //}
        
      }
  return (
    <tbody>
    <tr className=" divide-y divide-slate-700 ">
      <td></td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
        <button
          onClick={handleOnclickSeleccionarEnfermero}
          type="button"
          className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {item.MMCODM}
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {item.MMNomM}
      </td>
    </tr>
    {modalOnValidarEnfermoJefe? <ModalValidarEnfermefoJefeDevolucionesQx setmodalOnValidarEnfermoJefe={setmodalOnValidarEnfermoJefe}/>:null}
  </tbody>
  )
}

export default TablaListaPersonalEnfermeriaDevolucionesQx